import React from "react";

export default function Status({ value, update, items }) {
  return (
    <div className="flex gap-8">
      {items.map((i, index) => (
        <button
          key={"ksi" + index}
          className={`font-bold text-base ${
            value === i.value ? "text-secondary" : "text-disabled"
          }`}
          onClick={() => update(i.value)}
        >
          {i.label}
        </button>
      ))}
    </div>
  );
}
